module.exports = __webpack_public_path__ + "assets/img/banner-logo.09e364ab.png";